export enum TransactionType {
  Subscription = 'subscription',
  Purchase = 'purchase',
  Tip = 'tip',
}
